import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import { MARQUEE } from "@/lib/content";

const Ring = () => (
  <svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full animate-spin-slow pointer-events-none" aria-hidden="true">
    <defs><path id="ring" d="M100,100 m-92,0 a92,92 0 1,1 184,0 a92,92 0 1,1 -184,0" /></defs>
    <text className="fill-granate" style={{ fontSize: 7.2, letterSpacing: 2.6, fontFamily: "Montserrat", textTransform: "uppercase" }}>
      <textPath href="#ring" textLength="572" lengthAdjust="spacing">{MARQUEE.join(" · ")} · </textPath>
    </text>
  </svg>
);

const Medallion = () => (
  <motion.div
    initial={{ opacity: 0, scale: 0.9, rotate: -6 }}
    animate={{ opacity: 1, scale: 1, rotate: 0 }}
    transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
    className="relative mx-auto w-[92%] sm:w-[70%] lg:w-full max-w-[620px] aspect-square"
    data-testid="hero-medallion"
  >
    <Ring />
    <img src="/brand/sello.webp" alt="Sello de La Patrona: monograma PT sobre copa de cóctel rodeado de flores" className="absolute inset-[11%] w-[78%] h-[78%] rounded-full drop-shadow-[0_40px_60px_rgba(155,28,46,0.35)]" data-testid="hero-logo-image" />
  </motion.div>
);

const line = (d) => ({ initial: { opacity: 0, y: 30 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: d, ease: [0.22, 1, 0.36, 1] } });

export const Hero = () => (
  <section className="relative overflow-hidden hero-bg pt-[150px] sm:pt-[170px] pb-24 min-h-[100svh]" data-testid="hero-section">
    <img src="/brand/flowers-tl.png" alt="" className="pointer-events-none absolute -top-10 -left-16 w-56 sm:w-80 lg:w-[420px] opacity-90" />
    <img src="/brand/flowers-br.png" alt="" className="pointer-events-none absolute -bottom-24 -right-20 w-60 sm:w-96 lg:w-[460px] opacity-90" />
    <div className="grain" />
    <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-8 items-center">
      <div className="lg:col-span-7">
        <motion.p {...line(0.1)} className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />Eventos · Catering · Experiencias · Servicios corporativos</motion.p>
        <h1 className="mt-8 font-display text-ink leading-[0.95]" data-testid="hero-title">
          <motion.span {...line(0.2)} className="block text-5xl sm:text-7xl lg:text-[88px]">No es solo un evento,</motion.span>
          <motion.span {...line(0.35)} className="block italic text-ink/80 text-5xl sm:text-7xl lg:text-[80px] pl-6 sm:pl-16">es una</motion.span>
          <motion.span {...line(0.5)} className="block font-script text-granate text-6xl sm:text-8xl lg:text-[120px] mt-2 sm:mt-4">experiencia</motion.span>
        </h1>
        <motion.p {...line(0.65)} className="mt-10 max-w-lg text-base sm:text-lg text-ink/70 leading-relaxed">
          Diseñamos eventos, caterings y actos a medida con el alma de la hostelería y el rigor de quien no deja nada al azar. Los invitados disfrutan; la patrona se ocupa del resto.
        </motion.p>
        <motion.div {...line(0.8)} className="mt-10 flex flex-wrap items-center gap-6">
          <Link to="#cita" className="btn-shine inline-flex items-center gap-2 rounded-full bg-granate text-white px-7 py-4 font-brand text-xs font-semibold tracking-[0.18em] uppercase shadow-xl shadow-granate/30 hover:-translate-y-0.5 transition-transform" data-testid="hero-agenda-btn">
            <CalendarCheck className="w-4 h-4" /> Agenda una cita
          </Link>
          <a href="#servicios" className="font-brand text-xs font-semibold tracking-[0.18em] uppercase text-ink border-b border-ink pb-1 hover:text-granate hover:border-granate transition-colors" data-testid="hero-discover-link">Ver servicios</a>
        </motion.div>
      </div>
      <div className="lg:col-span-5"><Medallion /></div>
    </div>
    <a href="#historia" className="absolute bottom-8 left-1/2 -translate-x-1/2 eyebrow text-ink/50 hover:text-granate" data-testid="hero-scroll">Desliza</a>
  </section>
);
